// True only when the unread count grew since the last poll. A null/undefined
// previous value means this is the first read - never alert on mount.
export const isNewArrival = (prevUnread, currUnread) => prevUnread !== null && prevUnread !== undefined && currUnread > prevUnread

let audioCtx

// A short two-note chime via the Web Audio API - no asset to bundle. Best-effort:
// skipped when the tab is hidden or audio is blocked, and never throws.
export const playNotificationSound = () => {
  try {
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
      return
    }
    const Ctx = window.AudioContext || window.webkitAudioContext
    if (!Ctx) {
      return
    }
    if (!audioCtx) {
      audioCtx = new Ctx()
    }
    // AudioContext starts suspended until a user gesture; resume best-effort.
    if (audioCtx.state === 'suspended' && typeof audioCtx.resume === 'function') {
      audioCtx.resume()
    }

    const now = audioCtx.currentTime
    const gain = audioCtx.createGain()
    gain.connect(audioCtx.destination)
    gain.gain.setValueAtTime(0.0001, now)
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.01)
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35)

    const osc = audioCtx.createOscillator()
    osc.type = 'sine'
    osc.frequency.setValueAtTime(880, now)
    osc.frequency.setValueAtTime(1174.66, now + 0.12)
    osc.connect(gain)
    osc.start(now)
    osc.stop(now + 0.35)
  } catch (e) {
    // Sound is a nicety - never let it break the notification flow.
  }
}
